export const assistToolErrorMessages = {
    notEnoughContext: "Not enough context",
};
export class AssistToolError extends Error {
    constructor(message) {
        super(message);
        this.name = "AssistToolError";
    }
}
